<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
        <slot>

        </slot>



    </div>
    <!-- <div>
      <img src="static/img/flota-autici.png"/>
    </div> -->
  </navbar>
</template>
<script>
  import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'

  export default {
    components: {
      Navbar,
      NavbarToggleButton
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false,
        imgCars: 'static/img/flota-autici.png'
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        if ( !string || !string.charAt(0) ) return '';
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      }
    }
  }

</script>
<style scoped>
  .navbar {
    background-repeat: no-repeat;
    background-position: 97% 0;
    background-size: contain;
  }

</style>
